import React from "react";
import { motion } from "framer-motion";
import "./styles.css";

export default function App() {
  const [isOn, setIsOn] = React.useState(false);

  return (
    <div
      name="Switch"
      style={{
        width: 160,
        height: 100,
        backgroundColor: "rgba(255, 255, 255, 0.4)",
        borderRadius: 50,
        padding: 10,
        cursor: "pointer",
        // Flexbox
        display: "flex",
        justifyContent: isOn ? "flex-end" : "flex-start"
      }}
      onClick={() => setIsOn(!isOn)}
    >
      <motion.div
        name="Handle"
        style={{
          width: 80,
          height: 80,
          backgroundColor: "white",
          borderRadius: 40
        }}
        // Animation
        layout
        transition={{ type: "spring", stiffness: 700, damping: 30 }}
      />
    </div>
  );
}
